import { render, staticRenderFns } from "./form.vue?vue&type=template&id=606be949&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606be949",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('606be949')) {
      api.createRecord('606be949', component.options)
    } else {
      api.reload('606be949', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=606be949&scoped=true", function () {
      api.rerender('606be949', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/airTransport/airlinePushRecords/cmp/form.vue"
export default component.exports